module.exports = __webpack_public_path__ + "img/gp.1b37f260.png";